import React, { useState, useEffect, useSyncExternalStore } from 'react';
import KiemDuyetPage from '../components/admin/User';
import ListPage from '../components/admin/ListPage';
import FanPage from '../components/admin/FanPage';
import { httpss, s3_aws } from '../utils/host'
import { IoMenu, IoCalendar, IoBarChart, IoPeople, IoTicket, IoDocumentText } from 'react-icons/io5';
const AdminPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const tabs = [
    {
      id: 'ketqua',
      title: 'Bài viết',
      icon: <IoCalendar />,
      component: <ListPage />,
    },
    {
      id: 'fanpage',
      title: 'Fanpage',
      icon: <IoBarChart />,
      component: <FanPage />,
    },
    {
      id: 'kiemduyet',
      title: 'Người dùng',
      icon: <IoPeople />,
      component: <KiemDuyetPage />,
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const handleTabClick = (id) => {
    setActiveTab(id);
  };

  const handleOpenMenuMobile = (e) => {
    setIsMenuOpen(!isMenuOpen);
    if (e.target.id === 'form') {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  return (
    <div>
      <div className={`fixed top-0 left-0 z-0 lg:hidden`}>
        <button onClick={handleOpenMenuMobile} className="text-2xl border rounded-lg p-1 m-2 hover:bg-gray-200">
          {' '}
          <IoMenu />
        </button>
      </div>
      {/* Mobile */}
      {isMenuOpen && (
        <div
          id="form"
          className="z-50 w-full h-full overflow-auto fixed top-1/2 right-1/2 transform translate-x-1/2 -translate-y-1/2 bg-black/80 lg:hidden"
          onClick={handleOpenMenuMobile}
        >
          <div className="fixed top-[20%] left-[5%] right-[5%]">
            <nav>
              {tabs.map((tab) => (
                <div key={tab.id} className='px-2 mb-2'>
                  <button
                    onClick={() => handleTabClick(tab.id)}
                    className={`flex items-center w-full p-2 rounded ${
                      activeTab === tab.id ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {tab.icon}
                    <span className='ml-2'>{tab.title}</span>
                  </button>
                </div>
              ))}
            </nav>
          </div>
        </div>
      )}
      {/* Mobile */}

      <div className="flex h-screen overflow-hidden">
        {/* PC */}
        <div className="absolute left-0 top-0 z-9999 flex h-screen w-72.5 flex-col overflow-y-hidden bg-white duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 -translate-x-full w-64">
          <div className="">
          </div>
          <nav className="text-nowrap m-2">
            {tabs.map((tab) => (
              <div key={tab.id} className='px-2 mb-2'>
                <button
                  onClick={() => handleTabClick(tab.id)}
                  className={`flex items-center w-full p-2 rounded ${
                    activeTab === tab.id ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-400'
                  }`}
                >
                  {tab.icon}
                  <span className='ml-2'>{tab.title}</span>
                </button>
              </div>
            ))}
          </nav>
        </div>
        {/* PC */}

        <div className="w-full">
          {tabs.map((tab) =>
            activeTab === tab.id && <div key={tab.id}>{tab.component}</div>
          )}
          
        </div>
        
      </div>
    </div>
  );
}
export default AdminPage;

